import { detectAndDecode } from "./logTail";

export const truncateText = (text: string, limit: number) =>
  text.length > limit ? `${text.substring(0, limit - 3)}...` : text;

export function generateRandomString(length: number) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("");
}

export function decodeWithFallback(raw: ArrayBuffer | Uint8Array | string): string {
  if (typeof raw === "string") return raw;
  return detectAndDecode(raw instanceof Uint8Array ? raw : new Uint8Array(raw)).text;
}
